import React from 'react';

import { Button, Col, Row } from 'react-bootstrap';
import chevronSVG from "../../assets/images/chevron.svg";
import CustomSelect from '../Common/Select/CustomSelect';
export default function ByDress() {

  return (
    <div>
      <div>
            <div className='d-flex justify-content-between align-items-center'>
              <div className='Analytics-subtitle'>Other Sources of Advertising</div>
              <div>  <CustomSelect /></div>
            </div>
      </div>
      <div className='chart-border pt-4'>
        <Row>
          <Col lg={12} md={12}>
            <div className='chart-title d-flex ps-4 pt-3'>Total Revenue</div>
          </Col>



        </Row>

        <Row className=' px-lg-2 pt-3 pb-3 '>
          <Col className='tableTitle  ' lg={8}>OTHER SOURCES<img className='ps-2' src={chevronSVG} alt='chevron' /> </Col>
          <Col className='tableTitle  ' lg={4}>REVENUE (USD)<img className='ps-2' src={chevronSVG} alt='chevron' /></Col>

        </Row>
        <Row className=' px-lg-2 pt-3 pb-3 tableContentBg mb-3 ms-0 me-0'>
          <Col className='tableContent itemName' lg={8}>Name written here</Col>
          <Col className='tableContent' lg={4}><b>1,000</b></Col>


        </Row>
        <Row className=' px-lg-2 pt-3 pb-3 tableContentBg mb-3 ms-0 me-0'>
          <Col className='tableContent itemName' lg={8}>Name written here</Col>
          <Col className='tableContent' lg={4}><b>1,000</b></Col>


        </Row>
        <Row className=' px-lg-2 pt-3 pb-3 tableContentBg mb-3 ms-0 me-0'>
          <Col className='tableContent itemName' lg={8}>Name written here</Col>
          <Col className='tableContent' lg={4}><b>1,000</b></Col>


        </Row>
        <Row className=' px-lg-2 pt-3 pb-3 tableContentBg mb-3 ms-0 me-0'>
          <Col className='tableContent itemName' lg={8}>Name written here</Col>
          <Col className='tableContent' lg={4}><b>1,000</b></Col>


        </Row>
        <Row className=' px-lg-2 pt-3 pb-3 tableContentBg mb-3 ms-0 me-0'>
          <Col className='tableContent itemName' lg={8}>Name written here</Col>
          <Col className='tableContent' lg={4}><b>1,000</b></Col>


        </Row>
        <div className="page-button mb-3">
          <Button className="left-button-pagination"><img className='left-image-button-pagination' src={chevronSVG} alt='chevron' /></Button>
          <Button className="button-pagination current-page">1</Button>
          <Button className="button-pagination">2</Button>
          <Button className="button-pagination">3</Button>
          <Button className="button-pagination">4</Button>
          <Button className="button-pagination">5</Button>
          <Button className="right-button-pagination"><img className='right-image-button-pagination' src={chevronSVG} alt='chevron' /></Button>
        </div>
      </div>
      <p className='analytics-purpul-subtitle pt-3'>EXPORT REVENUE BASED ON OTHER SOURCES OF ADVERTISING<img className='right-image-button-pagination  pt-2 ps-1' src={chevronSVG} alt='chevron' /></p>
      <hr />
      <p className='analytics-purpul-subtitle pt-2'>EXPORT PROFIT BASED ON OTHER SOURCES OF ADVERTISING<img className='right-image-button-pagination  pt-2 ps-1' src={chevronSVG} alt='chevron' /></p>
      <hr />

    </div>
  );
}
